export default function Machines_B_5 (number = 1) {
  return {
    name: '大型储物仓',
    icon: '/static/img/machines/b5.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_5.js